export const municipalityTranslations = {
  ar: {
    revenues: {
      title: 'جبايات البلدية',
      confirmDelete: 'هل أنت متأكد من حذف هذه الجباية؟',
      confirmPost: 'هل أنت متأكد من إقرار هذه الجباية؟',
      posted: 'مقرة',
      cancelled: 'ملغاة',
      draft: 'مسودة',
      selectRevenueType: 'يرجى اختيار نوع الجباية',
      reportTitle: 'تقرير الجبايات',
      financialResourcesDept: 'إدارة الموارد المالية',
      revenueCollectionReport: 'تقرير إيرادات الجبايات',
      revenueType: 'نوع الجباية',
      reportingPeriod: 'الفترة الزمنية',
      totalRecords: 'إجمالي السجلات',
      reportDate: 'تاريخ التقرير',
      receiptNumber: 'رقم الإيصال',
      customerEntity: 'العميل / الجهة',
      grandTotal: 'الإجمالي العام المجمع',
      allTypes: 'كافة الأنواع',
      receipts: 'إيصال',
    },
    commercialCollection: {
      title: 'جباية المحلات التجارية',
      contactName: 'اسم المحل/المالك',
      outstandingAmount: 'المبلغ المتبقي',
      totalPaid: 'إجمالي المدفوع',
      latestDueDate: 'آخر تاريخ استحقاق',
      quickPay: 'دفع سريع',
      searchPlaceholder: 'البحث عن محل، مالك أو رقم هاتف...',
    },
  },
  en: {
    revenues: {
      title: 'Municipality Revenues',
      confirmDelete: 'Are you sure you want to delete this revenue?',
      confirmPost: 'Are you sure you want to post this revenue?',
      posted: 'Posted',
      cancelled: 'Cancelled',
      draft: 'Draft',
      selectRevenueType: 'Please select revenue type',
      reportTitle: 'Revenue Report',
      financialResourcesDept: 'Financial Resources Dept.',
      revenueCollectionReport: 'Revenue Collection Report',
      revenueType: 'Revenue Type',
      reportingPeriod: 'Reporting Period',
      totalRecords: 'Total Records',
      reportDate: 'Report Date',
      receiptNumber: 'Receipt #',
      customerEntity: 'Customer / Entity',
      grandTotal: 'Grand Total Amount',
      allTypes: 'All Types',
      receipts: 'Receipts',
    },
    commercialCollection: {
      title: 'Commercial Collection',
      contactName: 'Shop/Owner Name',
      outstandingAmount: 'Outstanding Amount',
      totalPaid: 'Total Paid',
      latestDueDate: 'Latest Due Date',
      quickPay: 'Quick Pay',
      searchPlaceholder: 'Search for shop, owner or phone...',
    },
  },
}
